import React, { Component } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

import { favourites } from "../api";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Map.css";
import axios from "axios";

//note: code formatted for ES6 here
export class MapContainer extends Component {
  map = null;
  state = {
    markers: [
      { lat: 38.7129146, lng: -9.1286218 },
      { lat: 38.7117206, lng: -9.1264315 },
      { lat: 38.7123872, lng: -9.1287935 },
    ],
    showInfo: false,
    mapHeight: "90.4vh",
    vicinity: "",
    name: "",
    rating: "",
    icon: "",
    place_id: "",
  };

  styledMap = {
    minHeight: this.state.mapHeight,
    maxHeight: "80vh",
  };

  componentDidMount() {
    setTimeout(() => {
      this.map = new window.google.maps.Map(document.getElementById("map"), {
        center: { lat: this.props.lat, lng: this.props.lng },
        zoom: 15,
        disableDefaultUI: true,
      });

      new window.google.maps.event.addListener(this.map, "click", () => {
        this.setState({
          showInfo: false,
        })
      });
      this.findCarRepair();
    }, 100);
  }

  createMarker = (position, name, vicinity, icon, place_id, rating) => {
    const google = window.google;
    //Obter favorite by place_îd

    let markerImageUrl = "/images/marker.png";

    const image = {
      url: markerImageUrl,
      size: new google.maps.Size(71, 71),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 34),
      scaledSize: new google.maps.Size(30, 40),
    };

    const marker = new google.maps.Marker({
      position: position,
      map: this.map,
      icon: image,
    });

    marker.addListener("click", () => {
      this.setState({
        showInfo: true,
        mapHeight: "73.4vh",
        vicinity: vicinity,
        name: name,
        rating: rating,
        icon: icon,
        place_id: place_id,
      });
    });
  };

  findCarRepair = () => {
    const google = window.google;
    const service = new google.maps.places.PlacesService(this.map);
    service.nearbySearch(
      {
        location: { lat: this.map.center.lat(), lng: this.map.center.lng() },
        radius: 5500,
        type: ["car_repair"],
      },
      (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (let i = 0; i < results.length; i++) {
            let lat = results[i].geometry.location.lat();
            let lng = results[i].geometry.location.lng();
            const name = results[i].name;
            const icon = results[i].icon;
            const rating = results[i].rating;
            const vicinity = results[i].vicinity;
            const place_id = results[i].place_id;
            console.log(results[i]);
            this.createMarker(
              { lat, lng },
              name,
              icon,
              vicinity,
              place_id,
              rating
            );
          }
        }
      }
    );
  };

  route = (icon) => {
    const google = window.google;
    let directionsService = new google.maps.DirectionsService();
    let directionsRenderer = new google.maps.DirectionsRenderer();
    let start = "Santa Apólonia, Lisboa";
    let request = {
      origin: start,
      destination: icon,
      travelMode: "DRIVING",
    };

    directionsService.route(request, (result, status) => {
      if (status === "OK") {
        directionsRenderer.setDirections(result);
        directionsRenderer.setMap(this.map);
      }
    });
  };

  handleFormSubmit = async (event) => {
    event.preventDefault();
    const { name, rating, icon } = this.state;
    await favourites(name, rating, icon);
    toast.dark(`${name} was added to your favourites!`);
    this.props.history.push("/favourites");
  };

  render() {
    const { name, rating, icon, vicinity, place_id } = this.state;
    return (
      <article className="showInfoBox">
        {this.state.showInfo && (
          <section>
            <form
              className="markerInfoBox"
              onSubmit={this.handleFormSubmit}
              method="POST"
            >
              <div className="markerInfoTop">
                <div className="markerInfoTopfix">
                  <img src="/images/locationlogo.png" />
                  <h1>{name}</h1>
                </div>

                {rating ? (
                  <div className="markerInfoRating">
                    <img src="/images/star.png" />
                    {rating}/5
                  </div>
                ) : (
                  <div className="markerInfoNoRating">
                  <img src="/images/star.png" />
                  <p>no rating</p>
                  </div>
                )}
              </div>

              <div className="markerInfoAddressBox">
                <div className="markerInfoAddress">
                  <p className="markerInfoAddressFix">Address</p>
                  <p>{icon}</p>
                </div>
                <button>
                  <img src="/images/unfav.png" />
                </button>
              </div>
            </form>

            <div className="markerInfoButtons">
              <Link
                style={{ textDecoration: "none", color: "black" }}
                to={{
                  pathname: `/addappointment`,
                  place: { name: name, icon: icon },
                }}
              >
                <button>
                  <img src="/images/addapp.png" />
                  <p>Schedule Appointment</p>
                </button>
              </Link>

              <button onClick={() => this.route(icon)}>
                <img src="/images/route.png" />
                <p>Directions</p>
              </button>
            </div>
          </section>
        )}

        <div style={this.styledMap} id="map" />
      </article>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyChTAd_4g0EIOc4qxZXRFm0193jC71QI08",
})(MapContainer);
